import { datadogRum } from '@datadog/browser-rum'
import { getEnvironment } from '@ubi/js-utils/environment'
import type {
    TransportAction,
    TransportMessage,
    TransportContext,
} from '@ubi/js-utils/logger'

export function initDatadog() {
    datadogRum.init({
        applicationId: '06fda4c5-16b9-4bcf-8cea-a0feb38cfe06',
        clientToken: 'pubb36445e69073a016905385f1fed03aa6',
        site: 'datadoghq.eu',
        service: 'front-configuration-app',
        version: '1.0.0',
        // https://docs.datadoghq.com/fr/getting_started/tagging/#d%C3%A9finition-des-tags
        env: getEnvironment().toLowerCase(),
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    })
}

export function transportHandler(
    message: TransportMessage,
    context: TransportContext
) {
    // console.error in DEV for easier debug (the error is still sent to datadog)
    if (getEnvironment() === 'DEVELOPMENT') {
        console.error(message)
    } else {
        datadogRum.addError(message, context)
    }
}

export function actionsHandler(
    name: TransportAction,
    context: TransportContext
) {
    datadogRum.addAction(name, context)
}
